var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.endAt)?_c('div',{staticClass:"player-countdown",class:_vm.isDanger ? 'player-countdown_is-danger' : ''},[_c('live-svg',{staticClass:"player-countdown__live"}),_c('span',[_vm._v(" "+_vm._s(_vm.timeString)+" ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }